import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import '../redux/tokenslice';
import { jwtDecode } from 'jwt-decode';
import { ErrorToastContainer } from '../whatsapp/function/CustomFunction';
import React from 'react';

function ApplicationProtectedRouting({ element }) {
    const location = useLocation();
    const Accesstoken = useSelector((state) => state.Token.value);

    if (Accesstoken && Accesstoken.length > 49) {
        let TokenValidate = TokenVerify(Accesstoken);
        if (TokenValidate.status) {
            const decoded = jwtDecode(Accesstoken);

            if ((!(location.pathname === '/client-area/whatsapp/dashboard' || location.pathname === '/client-area/whatsapp/tickets' || location.pathname === '/client-area/whatsapp/tickets/create' || location.pathname === '/client-area' || location.pathname === '/client-area/whatsapp/dashboard' || location.pathname === '/client-area/whatsapp/subscription' || location.pathname.startsWith('/client-area/gmb'))) && decoded.whatsapp_service_expire) {
                //    return location.pathname;
                return <Navigate to="/client-area/whatsapp/subscription" />;
            }

            return element;
        } else {
            ErrorToastContainer(TokenValidate.message);
            return <Navigate to="/" />;
        }

    } else {
        const path = location.pathname.substring(1);
        if (path === 'client-area/whatsapp/whatsapp-chats') {
            if (window && !window.closed) {
                window.close();
            }
        }
        ErrorToastContainer('Please Login');
        return <Navigate to="/" />;
    }
}

export default React.memo(ApplicationProtectedRouting);


export const TokenVerify = (token) => {
    try {
        const decoded = jwtDecode(token);
        if (!decoded || typeof decoded !== 'object') {
            return { status: false, message: "Unauthorized Access" };
        }

        // Check token expiration based on elapsed local active time
        // to avoid false "Session expired" errors caused by client-server clock skew / wrong client PC time
        if (decoded.exp) {
            const savedAt = localStorage.getItem('token_saved_at');
            const tokenLifetime = (decoded.exp && decoded.iat) 
                ? (decoded.exp - decoded.iat) 
                : 3600;

            if (savedAt) {
                const elapsedSeconds = (Date.now() - parseInt(savedAt, 10)) / 1000;
                if (elapsedSeconds < 0) {
                    // System clock was adjusted backwards; reset timestamp
                    localStorage.setItem('token_saved_at', Date.now().toString());
                } else if (elapsedSeconds > tokenLifetime) {
                    return { status: false, message: "Session expired" };
                }
            } else {
                localStorage.setItem('token_saved_at', Date.now().toString());
            }
        }

        return { status: true, message: "Token is valid" };
    } catch (error) {
        return { status: false, message: "Unauthorized Access" };
    }
};


